<ng-container *ngIf="breakPointObserve$ | async">
  <div
    class="btn-empty button-content"
    [style.min-width]="buttonWidth | px"
    cdkOverlayOrigin
    #filterColumnsTrigger="cdkOverlayOrigin"
    (click)="openDropDown()"
    [class.active]="isOpenDropDown"
  >
    <ng-content></ng-content>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="filterColumnsTrigger"
    [cdkConnectedOverlayOpen]="isOpenDropDown"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="backDropClick()"
    [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayPanelClass]="versionImpaired ? 'cdk-version-for-visually-impaired' : ''"
    cdkConnectedOverlayBackdropClass="transparent-backdrop"
  >
    <ng-container *ngTemplateOutlet="dropDownModalTemp"></ng-container>
  </ng-template>

  <ng-template #dropDownModalTemp>
    <div class="modal-container">
      <div class="modal-title">
        <span class="h3 ml16">{{ inputTitle }}</span>
        <button class="btn-empty" (click)="closeModal()">
          <svg [icon]="icons.Close" class="dark-gray-color svg24 close-icon" />
        </button>
      </div>

      <ng-container *ngIf="isVersionImpaired; else default">
        <ng-container *ngTemplateOutlet="versionImpaired"></ng-container>
      </ng-container>

      <div class="footer">
        <div class="horizontal-line"></div>
        <button class="btn-secondary medium mr16 mb16 ml16 mt16" (click)="apply()">{{ 'OTHER.SELECT' | translate }}</button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #default>
  <div class="dropdown" [style.width]="dropdownWidth | px">
    <mat-checkbox class="option-checkbox" [checked]="chooseAll" [indeterminate]="isIndeterminate" (change)="choseAllOptions($event.checked)">
      {{ chooseAllText | translate }}
    </mat-checkbox>
    <div class="horizontal-line"></div>
    <form class="options" [formGroup]="selectForm" [style.max-height]="dropdownMaxHeight | px">
      <div *ngFor="let control of optionsFormArray.controls; let i = index" formArrayName="options">
        <mat-checkbox class="option-checkbox" [formControlName]="i">
          <span [innerHTML]="options[i] && options[i].title || '' | safeHTML"></span>
        </mat-checkbox>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #versionImpaired>
  <div class="dropdown-impaired" [style.width]="dropdownWidth | px">
    <mat-checkbox class="impaired-checkbox h3-impaired" [checked]="chooseAll" [indeterminate]="isIndeterminate" (change)="choseAllOptions($event.checked)">
      {{ chooseAllText | translate }}
    </mat-checkbox>
    <div class="impaired-horizontal-line"></div>
    <form class="options" [formGroup]="selectForm" [style.max-height]="dropdownMaxHeight | px">
      <div class="impaired-option" *ngFor="let control of optionsFormArray.controls; let i = index" formArrayName="options">
        <mat-checkbox class="impaired-checkbox h3-impaired" [formControlName]="i">
          <span class="impaired-title" [innerHTML]="options[i].title || '' | safeHTML"></span>
        </mat-checkbox>
        <div class="impaired-horizontal-line"></div>
      </div>
    </form>
  </div>
</ng-template>
